import GenericGallery from "./GenericGallery";
import { houseData } from "./Config";

const House_client = () => (
  <GenericGallery 
    galleryData={houseData} // Ahora recibe un array directamente
    galleryType="viviendas"
    baseRoute="/galeria-viviendas"
  />
);

export default House_client;